import { API_KEY, APS_APP_ID, EVENT_SOURCE, PREFERREDLANGMAP, SUPPORTEDLANGUAGES, URLS } from '../constants';
import axios, { AxiosError, AxiosResponse, Method } from "axios";
import { APSResponse, AccessibleItem, EventType, Incident } from '../proptype';

declare global {
    interface Window {
        adobeIMS: any;
    }
}

export class SubscriptionService {
    private static instance: SubscriptionService;
    private locales: any;
    private subscription_url: any;
    private pns_url: any;
    private slack_url: any;
    private teams_profile_url: any;
    private teams_conversations_url: any;
    private headers = {
        'Authorization': '', // value needs to be updated before attaching to axios
        'x-api-key': API_KEY,
        'source': EVENT_SOURCE,
        'content-type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
    };


    public static init() {
        if (!SubscriptionService.instance) {
            SubscriptionService.instance = new SubscriptionService();
        }
        return SubscriptionService.instance;
    }
    private constructor() {
        this.subscription_url = URLS.SUBSCRIBE_URL;
        this.pns_url = URLS.PNS_URL;
        this.slack_url = URLS.SLACK_URL;
        this.teams_profile_url = URLS.TEAMS_PROFILE_URL;
        this.teams_conversations_url = URLS.TEAMS_CONVERSATIONS_URL;
    }

    public getIMSEntitlementCode(profile?: any): string[] {
        if (!profile) {
            const imsProfile = sessionStorage.getItem('adobeid_ims_profile');
            if (!imsProfile) {
                window.adobeid.redirect_uri = window.location.href;
                window.adobeIMS.signIn();
            } else {
                profile = JSON.parse(imsProfile);
            }

        }

        let entitlements: string[] = [];
        if (profile?.projectedProductContext?.length) {
            profile.projectedProductContext.forEach((context: any) => {
                if (!entitlements.includes(context.prodCtx.serviceCode)) {
                    entitlements.push(context.prodCtx.serviceCode);
                }
            });
        }

        return entitlements;
    }

    public getEntitlementCodeFromAPS(): Promise<string[]> {
        console.log('getEntitlementCodeFromAPS');
        if (!window.adobeIMS?.isSignedInUser()) {
            window.adobeid.redirect_uri = window.location.href;
            window.adobeIMS.signIn();
        }

        return new Promise((resolve, reject) => {
            console.log('getEntitlementCodeFromAPS 2');
            const entitlements = this.getIMSEntitlementCode();
            // if (entitlements.length) {
            //     resolve(entitlements);
            //     return;
            // }
            axios.post(URLS.APS_URL, {
                "appDetails":
                {
                    "nglAppVersion": "1.0",
                    "nglLibRuntimeMode": "NAMED_USER_ONLINE",
                    "nglLibVersion": "12.3",
                    "locale": "en_US",
                    "nglAppLaunchState": "WORKFLOW_STATE",
                    "appNameForLocale": `${APS_APP_ID}`,
                    "nglAppId": `${APS_APP_ID}`,
                    "appVersionForLocale": "1.0"
                }
            }, {
                headers: {
                    'Authorization': `Bearer ${window.adobeIMS?.getAccessToken().token}`,
                    'X-Api-Key': 'adobedotcom_status'
                }
            }).then((res: AxiosResponse) => {
                console.log('APS Response:', res);
                const response = res.data?.asnp?.payload;
                if (response) {
                    const result: APSResponse = JSON.parse(atob(response));
                    console.log('APS Response result:', result);
                    if (result.appProfile?.accessibleItems) {
                        const fiCodes = Array.prototype.concat.apply([], result.appProfile?.accessibleItems.map((item: AccessibleItem) => Object.keys(item.fulfillable_items || {})));
                        resolve(fiCodes);
                        console.log('fiCodes:', fiCodes);
                        return;
                    }
                    console.log('APS Response:', result);
                }
                resolve([]);
                return;

            }, (error: AxiosError) => {
                resolve([]);
            });
        })
    }

    public getSubscriptions(currentTab?: any, safe?: boolean) {
        let URL: string = (currentTab === "event") ? this.subscription_url : this.pns_url + "/selfSubscriptions";
        this.headers = {
            ...this.headers,
            'Authorization': 'Bearer ' + window.adobeIMS?.getAccessToken().token
        };
        if (safe) {
            URL += '?safe=true';
        }
        return axios.get(URL, { headers: this.headers });
    }

    public getSlackSubscription() {
        this.headers = {
            ...this.headers,
            'Authorization': 'Bearer ' + window.adobeIMS?.getAccessToken().token
        };

        return axios.get(this.slack_url, { headers: this.headers });
    }
    public removeSlackSubscription() {
        this.headers = {
            ...this.headers,
            'Authorization': 'Bearer ' + window.adobeIMS?.getAccessToken().token
        };

        return axios.delete(this.slack_url, { headers: this.headers });
    }

    public getTeamsSubscription(){
        let teamsProfile = this.getTeamsProfile();
        let teamsConversations = this.getTeamsConversations();
        return Promise.all([teamsProfile, teamsConversations]);
    }

    public getTeamsProfile(){
        this.headers = {
            ...this.headers,
            'Authorization': 'Bearer ' + window.adobeIMS?.getAccessToken().token
        };
        
        // Get the user's Adobe ID from the IMS profile
        const imsProfile = sessionStorage.getItem('adobeid_ims_profile');
        let adobeId = '';
        if (imsProfile) {
            const profile = JSON.parse(imsProfile);
            adobeId = profile.userId || '';
        }
        // Make GET request to TEAMS_CONVERSATIONS_URL with adobeId as query parameter
        const url = `${this.teams_profile_url}`;
        return axios.get(url, { headers: this.headers });
    }

    public getTeamsConversations() {
        this.headers = {
            ...this.headers,
            'Authorization': 'Bearer ' + window.adobeIMS?.getAccessToken().token
        };
        
        // Get profile directly from IMS instead of sessionStorage to avoid timing issues
        return window.adobeIMS?.getProfile()
            .then((profile: any) => {
                const adobeId = profile.userId || '';
                const url = `${this.teams_conversations_url}?adobeId=${adobeId}`;
                return axios.get(url, { headers: this.headers });
            })
            .catch((error: any) => {
                console.error('Failed to get profile for Teams conversations:', error);
                throw error;
            });
    }

    public addTeamsProfile(payload: any) {
        return axios({
            method: "post",
            headers: {
                ...this.headers,
                'Authorization': 'Bearer ' + window.adobeIMS.getAccessToken().token,
            },
            url: this.teams_profile_url,
            data: payload
        });
    }

    public subscibeProducts(payload: any) {
        return axios({
            method: "post",
            headers: {
                ...this.headers,
                'Authorization': 'Bearer ' + window.adobeIMS.getAccessToken().token,
            },
            url: this.pns_url + "/selfSubscriptions",
            data: payload
        })
    }

    public unSubscribeProduct(productId: any, subscriptions: any, timeZone: any, slackNotificationEnabled: boolean) {

        let payload: any = {
            "timeZone": timeZone,
            "language": this.getUserDetail().userLanguage,
            "source": EVENT_SOURCE,
            "subscriptions": [],
            "slackNotificationEnabled": slackNotificationEnabled
        };
        subscriptions.forEach((subscription: any) => {
            if (subscription.product.id !== productId) {
                let Obj: any = {
                    "product": {
                        "id": subscription.product.id,
                        "name": subscription.product.name,
                        "type": subscription.product.type
                    },
                    "cloudName": subscription.cloudName,
                    "eventType": subscription.eventType,
                    "regions": subscription.regions,
                    "environments": subscription.environments
                }
                if (subscription.productOfferings && subscription.productOfferings.length) {
                    Obj.productOfferings = subscription.productOfferings;
                }
                payload.subscriptions.push(Obj);
            }
        })


        this.headers = {
            ...this.headers,
            'Authorization': 'Bearer ' + window.adobeIMS.getAccessToken().token,
        };

        if (payload.subscriptions.length) {
            return axios({
                method: "post",
                headers: this.headers,
                url: this.pns_url + "/selfSubscriptions",
                data: payload
            }).then((response) => {
                this.clearMyEventsContextCache();
                return response;
            })
        } else {
            return this.deleteSelfSubscription()
        }
    }

    public setLocales(locales: any) {
        this.locales = locales;
    }
    public deleteSelfSubscription() {

        this.headers = {
            ...this.headers,
            'Authorization': 'Bearer ' + window.adobeIMS.getAccessToken().token,
        };

        return axios({
            method: "DELETE",
            headers: this.headers,
            url: this.pns_url + "/selfSubscriptions"
        }).then((response) => {
            this.clearMyEventsContextCache();
            return response;
        })

    }
    public getUserDetail() {
        let that = this;
        const imsProfile = sessionStorage.getItem('adobeid_ims_profile');
        if (!imsProfile) {
            window.adobeid.redirect_uri = window.location.href;
            window.adobeIMS.signIn();
        }

        let profile = imsProfile && JSON.parse(imsProfile),
            userLanguage = "English (United States)", langIndex;
        if (profile?.preferred_languages?.length) {
            langIndex = SUPPORTEDLANGUAGES.indexOf(profile.preferred_languages[0]);
        }

        if (langIndex !== undefined && langIndex !== -1) {
            let preferredLanguage: string = profile.preferred_languages.length ? PREFERREDLANGMAP[profile.preferred_languages[0]] : 'en-us';
            userLanguage = that.locales.languages[langIndex] || PREFERREDLANGMAP[preferredLanguage];
        }

        return {
            userLanguage: userLanguage,
            email: profile.email
        }

    }

    public validateTimeZone(timeZone: string) {
        return axios({
            method: 'GET',
            headers: {
                ...this.headers,
                'Authorization': 'Bearer ' + window.adobeIMS?.getAccessToken().token,
            },
            url: this.pns_url + "/selfSubscriptions/validate?timeZone=" + timeZone
        });
    }

    public isCommunication(eventType: string): Boolean {
        if ([EventType.cloud.toString(), EventType.global.toString(), EventType.product.toString()].includes(eventType)) {
            return true;
        }
        return false;
    }

    public updateSubscription(type: Method, timeZone: string, incident?: Incident, slackChannel?: any) {

        if (incident) {
            let currentRegions: any = incident.regions || [],
                payload: any = {
                    eventLanguage: this.getUserDetail().userLanguage,
                    eventSubscription: {
                        eventId: incident.incidentId,
                        severity: this.isCommunication(incident.eventType || "") ? incident.eventType : incident.severity || 'Maintenance',
                        eventStartTime: incident.startedOn,
                        eventUpdateTime: incident.updatedTime || 0,
                        eventEndTime: incident.endedOn || 0,
                        status: incident.status || "",
                        cloudNames: [incident.cloudName],
                        regions: Object.values(currentRegions).map((region: any) => {
                            return region.name;
                        }),
                        product: incident.productsAssociated.filter((service: any) => incident.productId === service.id)
                    },
                    eventSource: EVENT_SOURCE,
                    timeZone: timeZone
                };

            // send slack channel name in paylaod
            if (slackChannel) {
                payload.slack = { "slackChannel": slackChannel }
            }


            return axios({
                method: type,
                headers: {
                    ...this.headers,
                    'Authorization': 'Bearer ' + window.adobeIMS?.getAccessToken().token,
                },
                url: this.subscription_url,
                data: JSON.stringify(payload)
            }).then((response) => {
                this.clearMyEventsContextCache();
                return response;
            });
        } else {
            return Promise.reject();
        }
    }

    private myEventsContextCache: {
        eventSubscription: any[];
        selfSubscriptions: any[];
        entitlements: any[];
        timestamp: number;
    } | null = null;

    private static MY_EVENTS_CACHE_TTL_MS = 120000;

    private getCachedImsProfile(): Promise<any> {
        const cachedProfile = sessionStorage.getItem('adobeid_ims_profile');
        if (cachedProfile) {
            try {
                return Promise.resolve(JSON.parse(cachedProfile));
            } catch {
                // fall through to live profile fetch
            }
        }
        if (window.adobeIMS?.getProfile) {
            return window.adobeIMS.getProfile();
        }
        return Promise.resolve(null);
    }

    public fetchMyEventsContext(serviceRegistry: any, safe?: boolean): Promise<{
        eventSubscription: any[];
        selfSubscriptions: any[];
        entitlements: any[];
    }> {
        const now = Date.now();
        if (
            this.myEventsContextCache &&
            now - this.myEventsContextCache.timestamp < SubscriptionService.MY_EVENTS_CACHE_TTL_MS
        ) {
            return Promise.resolve({
                eventSubscription: this.myEventsContextCache.eventSubscription,
                selfSubscriptions: this.myEventsContextCache.selfSubscriptions,
                entitlements: this.myEventsContextCache.entitlements,
            });
        }

        return Promise.all([
            this.getSubscriptions("event", safe).then((result: any) => result.data).catch(() => []),
            this.getSubscriptions("product", safe).then((result: any) => result.data).catch(() => []),
            this.getCachedImsProfile(),
        ]).then(([eventSubscription, selfSubs, profile]) => {
            const entitlements = this.getImsEntitlementProducts(
                serviceRegistry.getServiceCodeMap(),
                profile
            );
            const selfSubscriptions = serviceRegistry.mergeOfferingsIntoProduct(selfSubs || []);
            const context = {
                eventSubscription: eventSubscription || [],
                selfSubscriptions,
                entitlements: entitlements || [],
            };
            this.myEventsContextCache = { ...context, timestamp: Date.now() };
            return context;
        });
    }

    public clearMyEventsContextCache() {
        this.myEventsContextCache = null;
    }

    public getImsEntitlementProducts(entitlements: any, profile?: any) {
        let imsServiceCode = this.getIMSEntitlementCode(profile);
        const imsEntitlementProducts: any = [];
        imsServiceCode.forEach((serviceCode: any) => {
            if (entitlements.get(serviceCode)) {
                imsEntitlementProducts.push(entitlements.get(serviceCode));
            }
        });
        return imsEntitlementProducts;
    }


}
